import React, { useEffect } from 'react';
import './acesso.page.scss';
import LoginComponent from '../../components/login/login.component';
import { Autocomplete, Button, TextField } from '@mui/material';
import CadastroComponent from '../../components/cadastro/cadastro.component';
import { EsqueciMinhaSenhaComponent } from '../../components/esqueci-minha-senha/esqueci-minha-senha.component';
import { UsuarioEfetuouLoginService, UsuarioEfetuouLogOutService } from '../../services/usuario-efetuou-login.service';
import UsuarioModel from '../../models/usuario.model';
import { useHistory } from 'react-router-dom';
import PainelAdminComponent from '../../components/painel-admin/painel-admin.component';
import SiteModel, { CopiasSitesModel } from '../../models/layout.model';
import { LoadingService } from '../../services/loading.service';
import { GetCopiaService } from '../../services/api-pages.service';
import { SnackService } from '../../services/snack.service';

export type AcessoPageProps = {
  site?: SiteModel;
}

export default function AcessoPage(props: AcessoPageProps) {

  const [showBox, setShowBox] = React.useState<string>('login');
  const [usuarioLogado, setUsuarioLogado] = React.useState<UsuarioModel>();
  const [site, setSite] = React.useState<SiteModel>();
  const [copia, setCopia] = React.useState<SiteModel>();
  const [listCopias, setListCopias] = React.useState<CopiasSitesModel[]>(site?.copias ? site?.copias : []);
  const [idCopia, setIdCopia] = React.useState<string>(copia?.id ? copia?.id : '');
  let history = useHistory();

  useEffect(() => {
    UsuarioEfetuouLoginService.getMSG().subscribe((usuarioService: any) => {
      setUsuarioLogado(usuarioService);
    });

    let usLogado = localStorage.getItem("user");
    if (usLogado) {
      setUsuarioLogado(JSON.parse(usLogado));
    }
  }, []);

  useEffect(() => {
    if (site && site.copia_em_producao) {
      GetCopia(site.copia_em_producao.toString());
    }
  }, [site]);

  useEffect(() => {
    //console.log(copia?.copia_em_producao)
    setCopia(copia);
  }, [copia]);

  const Sair = () => {
    localStorage.clear();
    UsuarioEfetuouLogOutService.sendMSG(true);
    setUsuarioLogado(undefined);

    window.location.href = '/area-cliente-a7apps';
  }

  const GetCopia = (id: string) => {
    LoadingService.sendLoadingAtivo(true);
    GetCopiaService({ ID: id }).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        //setCopia(JSON.parse(res.data.json));
        setCopia(res.data);
        setIdCopia(id);
        //console.log(JSON.parse(res.data.json));
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  }

  return (
    <>
      <section className="acesso flex flex-cv">
        <div className="container">
          {
            usuarioLogado ?
              <>
                <div className="login-bar">
                  <h4>Olá, {usuarioLogado.user_login}.</h4>
                  <div className="dir">
                    {
                      (listCopias && site) &&
                      <>
                        {
                          listCopias?.length > 1 &&
                          <Autocomplete
                            disablePortal
                            defaultValue={listCopias?.find(item => item.id === site.copia_em_producao)}
                            options={listCopias ? listCopias : []}
                            sx={{ width: 200 }}
                            renderInput={(params) => <TextField {...params} label="Carregar cópia" />}
                            onChange={(event, val) => {
                              if (val?.id) {
                                setCopia(undefined);
                                setIdCopia(val.id);
                                GetCopia(val.id);
                              }
                            }}
                          />
                        }
                      </>
                    }
                    <Button className='bt' onClick={Sair}>Sair</Button>
                  </div>
                </div>
                {
                  copia &&
                  <>
                    <PainelAdminComponent
                      idCopiaEmProd={site?.copia_em_producao ? site?.copia_em_producao.toString() : undefined}
                      isCopia={true}
                      idCopia={idCopia}
                      site={copia}
                      setCopiaEmProducao={val => setSite(prev => ({
                        ...prev,
                        copia_em_producao: parseInt(val)
                      }))}
                      setSite={(val) => {
                        setCopia(val);
                        if (val.copias) {
                          setListCopias(val.copias);
                        }
                      }} />
                  </>
                }

                {
                  (!copia && !idCopia) &&
                  <>
                    <PainelAdminComponent isCopia={false} site={props.site} setSite={(val) => {
                      setSite(val);
                      if (val.copias) {
                        setListCopias(val.copias);
                      }
                    }} />
                  </>
                }
              </>
              :
              <div className="box-login">
                {
                  showBox === 'login' &&
                  <div className="box">
                    <LoginComponent />
                    {/* <Button onClick={() => { setShowBox('cadastro') }}>Cadastre-se</Button> */}
                    <Button onClick={() => { setShowBox('esqueci-minha-senha') }}>Esqueci minha senha</Button>
                  </div>
                }
                {
                  // showBox === 'cadastro' &&
                  // <div className="box">
                  //   <CadastroComponent />
                  //   <Button onClick={() => { setShowBox('login') }}>Efetuar login</Button>
                  // </div>
                }
                {
                  showBox === 'esqueci-minha-senha' &&
                  <div className="box">
                    <EsqueciMinhaSenhaComponent />
                    <Button onClick={() => { setShowBox('login') }}>Efetuar login</Button>
                    {/* <Button onClick={() => { setShowBox('cadastro') }}>Cadastre-se</Button> */}
                  </div>
                }
              </div>
          }
        </div>
      </section>
    </>
  );
}